import auth from './auth'

const getAuthenticatedHeaders = async (headers = {}) => {
  const user = auth.currentUser
  if (!user) {
    throw new Error('Not authenticated')
  }

  const token = await user.getIdToken()

  return {
    ...headers,
    Authorization: `Bearer ${token}`
  }
}

export default getAuthenticatedHeaders
